/**
 *
 * UserEditPage
 *
 */
import { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import AppContainer from "components/AppContainer/AppContainer";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import UserEditForm from "components/UserEditForm/UserEditForm";
import * as PropTypes from "prop-types";
import PasswordChanger from "components/PasswordChanger/PasswordChanger";
import PracticeInfo from "components/PracticeInfo/PracticeInfo";
import { changeLocale } from "containers/LanguageProvider/actions";
import History from "utils/history";
import ForegroundBlob, {
  BlobContent,
} from "basicComponents/ForegroundBlob/ForegroundBlob";
import {
  makeSelectLanguages,
  makeSelectPasswordFailed,
  makeSelectPasswordInProgress,
  makeSelectUser,
  makeSelectUserFailed,
  makeSelectUserInProgress,
} from "./selectors";
import reducer from "./reducer";
import saga from "./saga";
import messages from "./messages";
import {
  changePassword,
  changeUser,
  getLanguageAction,
  getUserAction,
  resetPassMessage,
} from "./actions";
import {
  getPracticesAction,
  selectPracticeAction,
} from "../PracticePage/actions";
import {
  makeSelectPractice,
  makeSelectPractices,
} from "../PracticePage/selectors";
import DentistOverview from "../../components/DentistOverview/DentistOverview";
import {
  createDentistAction,
  deleteDentistAction,
  filterDentistAction,
  resetDentistDeleteMessage,
  resetDentists,
} from "../App/actions";
import Header from "../../basicComponents/Header/Header";
import {
  makeSelectDentistDeleted,
  makeSelectDentistDeleteFailed,
  makeSelectFilteredDentists,
} from "../App/selectors";
import ActionButton from "basicComponents/ActionButton/ActionButton";
import { getBearer, getUser, getUserId } from "utils/userStorage";
import { parseJwt } from "utils/OauthUtils";
import RefrezhButton from "components/RefrezhButton";

export class UserEditPage extends Component {
  static propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func.isRequired,
    getLanguages: PropTypes.func.isRequired,
    getUser: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired,
    changeLocale: PropTypes.func.isRequired,
    practices: PropTypes.array.isRequired,
    passwordFailed: PropTypes.object.isRequired,
    passwordInProgress: PropTypes.bool.isRequired,
    languages: PropTypes.array.isRequired,
    getPractices: PropTypes.func.isRequired,

    practice: PropTypes.object.isRequired,
    resetDentists: PropTypes.func.isRequired,
    filterDentist: PropTypes.func.isRequired,
    filteredDentists: PropTypes.array.isRequired,
    userInProgress: PropTypes.bool.isRequired,
    userFailed: PropTypes.object.isRequired,
    resetPassword: PropTypes.func,

    dentistDeleteFailed: PropTypes.object,
    onDentistMessageReset: PropTypes.func,
    dentistDeleted: PropTypes.bool,
  };

  state = {};

  componentDidMount() {

    fetch(`${__URLS__["api"]}users/${getUserId()}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      }
    }).then(res => res.json()).then((data) => {
      this.setState({user:data})
    })

    if (this.props.practices.length === 0) {
      this.props.getPractices();
    }
    this.props.getUser();
    this.props.getLanguages();
  }

  componentWillUnmount() {
    // this is to clear the error message of invalid password on leave of the page
    this.props.resetPassword();
    this.props.onDentistMessageReset();
  }

  handleLanguageChanged = language => {
    this.props.changeLocale(language);
  };

  handlePracticeChangeClicked = () => {
    // this null makes it so that there is no selected practice when you go back to practice page.
    this.props.selectPractice(null);
    History.push("/practice");
  };

  handleDentistFilterChanged = (filter, kip) => {
    this.props.filterDentist(filter, kip);
  };

  render() {
    return (
      <AppContainer
        header={<FormattedMessage {...messages.header} />}
        color="blue"
      >
        <ForegroundBlob withClose>
          <BlobContent>
            <ContentWidget large>
              {this.props.user && (
                <UserEditForm
                  onLanguageChanged={this.handleLanguageChanged}
                  disabled={this.props.userInProgress}
                  userInProgress={this.props.userInProgress}
                  userFailed={this.props.userFailed}
                  languages={this.props.languages}
                  passwordInProgress={this.props.passwordInProgress}
                  passwordFailed={this.props.passwordFailed}
                  changePassword={this.props.changePassword}
                  onUpdateUser={this.props.updateUser}
                  user={this.props.user}
                />
              )}
            </ContentWidget>
            <ContentWidget>
              <PasswordChanger
                disabled={this.props.userInProgress}
                inProgress={this.props.passwordInProgress}
                failedMessages={this.props.passwordFailed}
                onChangePassword={this.props.changePassword}
              />
            </ContentWidget>
          </BlobContent>
        </ForegroundBlob>
        <ForegroundBlob>
          <CustomBlobContent>
            <ContentWidget marginRight large>
              <PracticeInfo
                multiColumnPracticeInfo
                practices={this.props.practices}
                onClick={this.handlePracticeChangeClicked}
                practice={this.props.practice}
              />
            </ContentWidget>
            <DentistWidget large>
              <Header disableMargin>
                <FormattedMessage {...messages.dentists_header} />
              </Header>
              <DentistOverview
                deleteDentist={this.props.deleteDentist}
                createDentist={this.props.createDentist}
                onFilter={this.handleDentistFilterChanged}
                showTableContent
                items={this.props.filteredDentists}
                practice={this.props.practice}
                height={235}
                failedDeleteMessage={this.props.dentistDeleteFailed}
                dentistDeleted={this.props.dentistDeleted}
              />
            </DentistWidget>
          </CustomBlobContent>

          {this.props.practice.allowedToOrder && (
            <>
              <Divider />
              <div style={{display:'flex',justifyContent:'space-around'}}>
                <ActionContainer>
                  <Header>
                    <FormattedMessage {...messages.product_settings} />
                  </Header>
                  <ActionButton
                    onClick={() =>
                      History.push("/dashboard/practice/product/defaults")
                    }
                  >
                    <FormattedMessage {...messages.product_button} />
                  </ActionButton>
                </ActionContainer>

                <ActionContainer>
                  <Header>
                    3shape mondscanner koppelen
                  </Header>
                  <div style={{display:'flex',justifyContent:'center', marginTop:''}}>
                    {(() => {

                      var jwt
                      if(this.state?.user?.id_token){
                        console.log(this.state.user)
                        jwt = parseJwt(this.state?.user?.id_token)
                      }

                      if(jwt && jwt.exp > (Date.now() / 1000)){
                        return <RefrezhButton onClick={() => {
                          
                          fetch(`${__URLS__["api"]}admin/Logout`, {
                            method: 'POST',
                            headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${getBearer()}`,
                            }
                          }).then(res => res.text()).then(() => {
                            localStorage.removeItem('jwt')
                            // location.reload()
                            // var user = getUser()
                            // console.log(jwt)
                            var id_token = this.state?.user?.id_token
                            console.log(id_token)
                            let identitybaseurl = __URLS__["threeshapeidentity"]
                            // let redirecturi = encodeURIComponent(window.location.href)
                            let redirecturi = encodeURIComponent(window.location.origin + "/threeshapelogout")
                            let state = encodeURIComponent(window.location.href)
                            window.location.href = `${identitybaseurl}/connect/endsession?id_token_hint=${id_token}&post_logout_redirect_uri=${redirecturi}&state=${state}`
                            // https://staging-identity.3shape.com/connect/endsession
                          })
                        }} >logout</RefrezhButton>
                      }else{
                        return <Threeshapelogin></Threeshapelogin>
                      }
                    })()}
                  </div>
                </ActionContainer>
              </div>
            </>
          )}
        </ForegroundBlob>
      </AppContainer>
    );
  }
}

function MaxWidth({ large, medium }) {
  if (large) {
    return 50;
  }

  if (medium) {
    return 40;
  }

  return 26;
}

const CustomBlobContent = styled.div`
  max-width: 1500px;
  @media (min-width: 1600px) {
    flex-direction: row;
  }
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 276px;
  flex-direction: column;
`;
const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  margin: 25px 0;
  background-color: rgba(0, 0, 0, 0.56);
`;

const MessagesButton = styled.div``;

const ContentWidget = styled.div`
  display: inline-block;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  ${({ marginRight, theme }) =>
    marginRight && `margin-right: ${theme.margin * 2}rem;`};

  ${({ theme }) => theme.desktopUp`
    max-width: ${MaxWidth}rem;
  `};
`;

const DentistWidget = styled.div`
  max-width: 100%;
  min-height: 100%;
  ${({ marginRight, theme }) =>
    marginRight && `margin-right: ${theme.margin * 2}rem;`};

  ${({ theme }) => theme.desktopUp`
    max-width: ${MaxWidth}rem;
  `};
`;

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  passwordFailed: makeSelectPasswordFailed(),
  passwordInProgress: makeSelectPasswordInProgress(),
  languages: makeSelectLanguages(),
  userFailed: makeSelectUserFailed(),
  userInProgress: makeSelectUserInProgress(),
  practice: makeSelectPractice(),
  practices: makeSelectPractices(),
  filteredDentists: makeSelectFilteredDentists(),
  dentistDeleteFailed: makeSelectDentistDeleteFailed(),
  dentistDeleted: makeSelectDentistDeleted(),
});

// This page is still using the App reducer and saga instead of DentistOverviewPage.
// for filterDentist, createDentist and deleteDentists.

function mapDispatchToProps(dispatch) {
  return {
    changeLocale: locale => dispatch(changeLocale(locale)),
    getUser: () => dispatch(getUserAction()),
    updateUser: (userData, callback) =>
      dispatch(changeUser(userData, callback)),
    changePassword: (oldPass, newPass, callback) =>
      dispatch(changePassword(oldPass, newPass, callback)),
    getLanguages: () => dispatch(getLanguageAction()),
    getPractices: () => dispatch(getPracticesAction()),
    selectPractice: practice => dispatch(selectPracticeAction(practice)),
    createDentist: (dentist, callback, existing) =>
      dispatch(createDentistAction(dentist, callback, existing)),
    filterDentist: (text, practiceId) =>
      dispatch(filterDentistAction(text, practiceId)),
    resetDentists: () => dispatch(resetDentists()),
    deleteDentist: dentist => dispatch(deleteDentistAction(dentist)),
    resetPassword: () => dispatch(resetPassMessage()),
    onDentistMessageReset: () => dispatch(resetDentistDeleteMessage()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "userEditPage", reducer });
const withSaga = injectSaga({ key: "userEditPage", saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(UserEditPage);
